import profilePic from '@/assets/imgs/svg/profile.svg';

export const reviews = [
  {
    index: 0,
    rating: 5,
    text: 'The korean hairdresser here really knows what she is doing👍 She looks into details and brings out the best outcome. Literally so experienced and even friendly. The price is also affordable, definitely going back for my next hair day🥰💗🎀',
    displayName: 'Jisu P.',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/8j6T4fTYVPZyiAqz6',
  },
  {
    index: 1,
    rating: 5,
    text: 'I am absolutely thrilled with the perfect service I received at JOA hair! my hairdresser was truly amazing! Not only did she listen to my needs, but she also offered expert advice and guidance to ensure my baby girl got the perfect look',
    displayName: 'Yeonjeong K.',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/fk3h7EEMm9jtjNSM8',
  },
  {
    index: 2,
    rating: 5,
    text: 'Thank you Sarah for her excellent job. I really love the hair highlights she did for me. 100% recommend with good value and customer services ! Will definitely recommend everyone to come here for a haircut!',
    displayName: 'Henry N.',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/mJPqEbXbHX1CQkR5A',
  },
  {
    index: 3,
    rating: 5,
    text: 'Easily accessible ! I highly recommend the Hair salon. There is amazing Japanese stylist who name is Miyuki. Thank you for your very helpful advice and change my life:)',
    displayName: '小.未',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/UVsurx29RQJMCL1V6',
  },
  {
    index: 4,
    rating: 5,
    text: '200% recommend JOA hair salon and the best hair stylist Sara! It was so easy to park here and there are good cafes nearby. The staffs are very friendly and approachable. I got my hair permanently straightened and also got a haircut. Absolutely LOVE It. I’ve been going to Sara for couple of years already 👍🏻Thank you :)',
    displayName: 'CK',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/288XaQvhAnAnVLLT9',
  },
  {
    index: 5,
    rating: 5,
    text: 'I had such a wonderful experience at the salon! It was my first time there and they were all really welcoming and listened to what I wanted. Sarah is an amazing hairdresser and a lovely person. She made me feel really comfortable and I couldn’t be more happy with the haircut I got. I’ll be back for sure!',
    displayName: 'Abril T.',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/fN9KW78nSE1XsLRx6',
  },
  {
    index: 6,
    rating: 5,
    text: 'I am absolutely amazed by how much I love my hair and the incredible job Miyuki did with both the styling and coloring. She is an extremely professional stylist and I highly recommend this salon as one of the friendliest place to go. 💯 Definitely will be back 😀',
    displayName: 'Shonal D.',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/3mSUBxuwwkDKLnuVA',
  },
];

export const storybookText = [
  {
    index: 0,
    rating: 5,
    text: '테스트1!!!!!!!!!!!!!!!!!!!!!!!!',
    displayName: '짱구',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/8j6T4fTYVPZyiAqz6',
  },
  {
    index: 1,
    rating: 5,
    text: '테스트2!!!!!!!!!!!!!!!!!!!!!!!!',
    displayName: '짱아',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/fk3h7EEMm9jtjNSM8',
  },
  {
    index: 2,
    rating: 5,
    text: '테스트3!!!!!!!!!!!!!!!!!!!!!!!!',
    displayName: '짱구아빠',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/mJPqEbXbHX1CQkR5A',
  },
  {
    index: 3,
    rating: 5,
    text: '테스트4!!!!!!!!!!!!!!!!!!!!!!!!',
    displayName: '짱구엄마',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/UVsurx29RQJMCL1V6',
  },
  {
    index: 4,
    rating: 5,
    text: '테스트5!!!!!!!!!!!!!!!!!!!!!!!!',
    displayName: '흰둥이',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/288XaQvhAnAnVLLT9',
  },
  {
    index: 5,
    rating: 5,
    text: '테스트6!!!!!!!!!!!!!!!!!!!!!!!!',
    displayName: '맹구',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/fN9KW78nSE1XsLRx6',
  },
  {
    index: 6,
    rating: 5,
    text: '테스트7!!!!!!!!!!!!!!!!!!!!!!!!',
    displayName: '유리',
    photoUri: profilePic,
    uri: 'https://maps.app.goo.gl/3mSUBxuwwkDKLnuVA',
  },
];
